import { createStateSelectorHook } from 'src/lib/sweetState';
import { ImageStyleStore } from 'src/store';

const useImageStyleState = createStateSelectorHook(ImageStyleStore, [
  'generalStyles',
  'workspaceStyles',
]);

export const useImageStyles = ({ visualLanguageId } = {}) => {
  const { generalStyles, workspaceStyles } = useImageStyleState();

  return {
    generalImageStyles: generalStyles || [],
    workspaceImageStyles:
      workspaceStyles && visualLanguageId
        ? workspaceStyles.filter((style) => style.visualLanguageId === visualLanguageId)
        : workspaceStyles || [],
  };
};
